var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7143C0 12.7675 0.643591 12 1.4375 12H4.3125C5.10641 12 5.75 12.7675 5.75 13.7143V22.2857C5.75 23.2325 5.10641 24 4.3125 24H1.4375C0.643591 24 0 23.2325 0 22.2857V13.7143Z",
    fill: "#7F3DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 6.85714C8.625 5.91037 9.26859 5.14286 10.0625 5.14286H12.9375C13.7314 5.14286 14.375 5.91037 14.375 6.85714V22.2857C14.375 23.2325 13.7314 24 12.9375 24H10.0625C9.26859 24 8.625 23.2325 8.625 22.2857V6.85714Z",
    fill: "#7F3DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 1.71429C17.25 0.767513 17.8936 0 18.6875 0H21.5625C22.3564 0 23 0.767512 23 1.71429V22.2857C23 23.2325 22.3564 24 21.5625 24H18.6875C17.8936 24 17.25 23.2325 17.25 22.2857V1.71429Z",
    fill: "#7F3DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.1eaa9479.svg";
export { ForwardRef as ReactComponent };